import React from 'react';
import { BlocTableau } from '../../types/chat';

const formatCellule = (v: string | number | null) =>
  v === null || v === undefined ? '—' : typeof v === 'number' ? v.toLocaleString('fr-FR', { maximumFractionDigits: 2 }) : v;

export const ChatTable: React.FC<{ bloc: BlocTableau }> = ({ bloc }) => (
  <figure style={{ margin: '10px 0', overflowX: 'auto' }}>
    <figcaption style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-heading, #111)', marginBottom: 6 }}>{bloc.title}</figcaption>
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
      <thead>
        <tr>
          {bloc.columns.map((c) => (
            <th key={c} style={{ textAlign: 'left', padding: '6px 8px', borderBottom: '1px solid var(--border-color, #e8e8e8)', color: 'var(--text-muted, #888)', fontWeight: 600 }}>{c}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {bloc.rows.map((ligne, i) => (
          <tr key={i}>
            {ligne.map((v, j) => (
              <td key={j} style={{ padding: '6px 8px', borderBottom: '0.5px solid var(--border-color, #e8e8e8)', textAlign: typeof v === 'number' ? 'right' : 'left', fontVariantNumeric: 'tabular-nums' }}>
                {formatCellule(v)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
    <div style={{ fontSize: 10, color: 'var(--text-muted, #888)', marginTop: 4 }}>
      Source : {bloc.source}{bloc.date_donnees ? ` — ${bloc.date_donnees}` : ''}
    </div>
  </figure>
);
